import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { ToastProvider } from '@clari/ui'
import { AdminLayout } from '@/components/AdminLayout'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { Login } from '@/pages/Login'
import { Users } from '@/pages/Users'
import { UserDetail } from '@/pages/UserDetail'
import { Accounts } from '@/pages/Accounts'
import { AccountDetail } from '@/pages/AccountDetail'
import { Transactions } from '@/pages/Transactions'
import { FxConversions } from '@/pages/FxConversions'
import { Reviews } from '@/pages/Reviews'
import { RiskAssessments } from '@/pages/RiskAssessments'
import { Security } from '@/pages/Security'
import { Kyc } from '@/pages/Kyc'
import { AuditLogs } from '@/pages/AuditLogs'
import { Webhooks } from '@/pages/Webhooks'
import { BusinessModel } from '@/pages/BusinessModel'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Navigate to="/users" replace />} />
              <Route path="/users" element={<Users />} />
              <Route path="/users/:id" element={<UserDetail />} />
              <Route path="/accounts" element={<Accounts />} />
              <Route path="/accounts/:id" element={<AccountDetail />} />
              <Route path="/transactions" element={<Transactions />} />
              <Route path="/fx-conversions" element={<FxConversions />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/risk-assessments" element={<RiskAssessments />} />
              <Route path="/security" element={<Security />} />
              <Route path="/kyc" element={<Kyc />} />
              <Route path="/audit-logs" element={<AuditLogs />} />
              <Route path="/webhooks" element={<Webhooks />} />
              <Route path="/business-model" element={<BusinessModel />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  )
}
